import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/user-groups';
import { UserGroupListItem } from '@rootCommon/types/user-group';
import {
  ListResultState, SortingBy, OrderBy, IdType,
} from '@rootCommon/types/common';

type Action = ActionType<typeof actions>;
type OwnState = { createdUserGroupId: IdType | null };
export type UserGroupsState = ListResultState<UserGroupListItem> & OwnState;

const initState: UserGroupsState = {
  data: null,
  loading: false,
  error: null,
  filter: { search: '', orderBy: OrderBy.DATE_CREATED, sorting: SortingBy.ASC },
  createdUserGroupId: null,
};

export const userGroupsReducer = (state = initState, action: Action): UserGroupsState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchUserGroups.request):
      return { ...state, loading: true, error: null };
    case getType(actions.fetchUserGroups.success):
      return { ...state, loading: false, data: { items: action.payload.items, total: action.payload.total } };
    case getType(actions.fetchUserGroups.failure):
      return { ...state, loading: false, error: action.payload };

      // delete
    case getType(actions.deleteUserGroup.request):
      return { ...state, loading: true, error: null };
    case getType(actions.deleteUserGroup.success): {
      const items = state.data?.items.filter((item) => action.payload !== item.id) || null;
      const total = items?.length || 0;

      return { ...state, loading: false, data: items ? { items, total } : null }; }
    case getType(actions.deleteUserGroup.failure):
      return { ...state, loading: false, error: action.payload };

      // filter
    case getType(actions.setUserGroupsFilter):
      return { ...state, filter: action.payload };

      // filter
    case getType(actions.setCreatedUserGroupId):
      return { ...state, createdUserGroupId: action.payload };

      // default
    default:
      return state;
  }
};

export default userGroupsReducer;
